// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.widget-container {
    width: 98vw;
    height: auto;
    padding:0.25em;
    color: black;
}

.widget-date-container{
  margin-left: 0.8em;
}

.edit-wiget-buttons-container{
    display: flex;
    align-items: end; 
    flex-wrap: wrap; /* Allow wrapping of child elements */
    gap: 1em; /* Add space between child elements */
    margin: 0.25em 0.5em;
}

.widget-card {
    width: 97%;
    margin: 1em 0.5em;
    padding: 0.5em;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 1px 1px 2px 4px rgba(0, 0, 0, 0.1); /* Shadow effect */
    transition: box-shadow 0.3s ease; /* Smooth transition */
  }
  
.widget-card:hover {
    box-shadow: 2px 2px 4px 6px rgba(0, 0, 0, 0.2); /* Increase shadow size on hover */
  }

.widget-charts-container {
    width: 100%;
}

.widget-chart-template{
    width: 100%;
  }
  
.widget-chart-selector-container {
    display: flex;
    padding: 0.25em;
    gap: 0.5em;
  }
  
  .widget-select-box-container{
    display: flex;
    flex-wrap: wrap;
    gap: 0.25em;
  }
  
  .widget-tag-box-container{
    display: flex;
    flex-wrap: wrap;
    gap: 0.25em;
  }
  

  .widget-label-text {
    font-size: 0.75em;
    color: black;
  }
  
  .widget-chart-header {
    color: black;
    font-size: 0.75em;
    font-weight: bold;
  }
  
  .widget-selected-machine {
    font-weight: normal; /* Set font weight to normal */
    color: #555; /* Set text color */
  }
  
  .widget-selectbox-with-min-width{
    min-width: 7.5em;
  }
  
  .widget-tagbox-with-min-width{
    min-width: 20em;
  }
  
  .circular-style {
    overflow: scroll;
    overflow-y: hidden;
    display: flex;
  }`, "",{"version":3,"sources":["webpack://./src/components/edit-widgets/editWidgets.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe,EAAE,qCAAqC;IACtD,QAAQ,EAAE,qCAAqC;IAC/C,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,8CAA8C,EAAE,kBAAkB;IAClE,gCAAgC,EAAE,sBAAsB;EAC1D;;AAEF;IACI,8CAA8C,EAAE,kCAAkC;EACpF;;AAEF;IACI,WAAW;AACf;;AAEA;IACI,WAAW;EACb;;AAEF;IACI,aAAa;IACb,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,WAAW;EACb;;;EAGA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB,EAAE,8BAA8B;IACnD,WAAW,EAAE,mBAAmB;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf","sourcesContent":[".widget-container {\n    width: 98vw;\n    height: auto;\n    padding:0.25em;\n    color: black;\n}\n\n.widget-date-container{\n  margin-left: 0.8em;\n}\n\n.edit-wiget-buttons-container{\n    display: flex;\n    align-items: end; \n    flex-wrap: wrap; /* Allow wrapping of child elements */\n    gap: 1em; /* Add space between child elements */\n    margin: 0.25em 0.5em;\n}\n\n.widget-card {\n    width: 97%;\n    margin: 1em 0.5em;\n    padding: 0.5em;\n    border-radius: 4px;\n    background-color: #ffffff;\n    box-shadow: 1px 1px 2px 4px rgba(0, 0, 0, 0.1); /* Shadow effect */\n    transition: box-shadow 0.3s ease; /* Smooth transition */\n  }\n  \n.widget-card:hover {\n    box-shadow: 2px 2px 4px 6px rgba(0, 0, 0, 0.2); /* Increase shadow size on hover */\n  }\n\n.widget-charts-container {\n    width: 100%;\n}\n\n.widget-chart-template{\n    width: 100%;\n  }\n  \n.widget-chart-selector-container {\n    display: flex;\n    padding: 0.25em;\n    gap: 0.5em;\n  }\n  \n  .widget-select-box-container{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.25em;\n  }\n  \n  .widget-tag-box-container{\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.25em;\n  }\n  \n\n  .widget-label-text {\n    font-size: 0.75em;\n    color: black;\n  }\n  \n  .widget-chart-header {\n    color: black;\n    font-size: 0.75em;\n    font-weight: bold;\n  }\n  \n  .widget-selected-machine {\n    font-weight: normal; /* Set font weight to normal */\n    color: #555; /* Set text color */\n  }\n  \n  .widget-selectbox-with-min-width{\n    min-width: 7.5em;\n  }\n  \n  .widget-tagbox-with-min-width{\n    min-width: 20em;\n  }\n  \n  .circular-style {\n    overflow: scroll;\n    overflow-y: hidden;\n    display: flex;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
